// LogoutSection.js
import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { secureLocalStorage ,secureSessionStorage} from "store/SecureStorage";


const LogoutSection = ({ open, onClose }) => {
    const navigate = useNavigate();

    const handleConfirm = () => {
        secureLocalStorage.clear();
        secureSessionStorage.clear();
        navigate('/login');
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle align="center">Confirm Logout</DialogTitle>
            <DialogContent>
                <Typography align="center">Are you sure you want to logout?</Typography>
            </DialogContent>
            <DialogActions sx={{ justifyContent: 'center', pb: 2 }}>
                <Button variant="outlined" onClick={handleCancel}>
                    Cancel
                </Button>
                <Button variant="contained" color="error" onClick={handleConfirm}>
                    Logout
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default LogoutSection;
